import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  SelectField,
  TextField,
  Loadable,
  EntitySelector
} from "components/support";

export default class FilterView extends Component {
  static status = [
    { value: "all", label: "Todos os produtos" },
    { value: "active", label: "Produtos ativos" },
    { value: "deleted", label: "Produtos excluídos" }
  ];

  static inventories = [
    { value: "all", label: "Todo o estoque" },
    { value: "positive", label: "Estoque positivo" },
    { value: "zero", label: "Estoque zerado" },
    { value: "negative", label: "Estoque negativo" }
  ];

  constructor(props) {
    super(props);

    this.state = {
      status: "active",
      stock: "all",
      code: "",
      name: "",
      category: {
        uuid: "",
        name: ""
      }
    };
  }

  onSelectCategory(category) {
    const { onFilter } = this.props;
    this.setState({ category }, () => onFilter(this.state));
  }

  handleChange(field, value) {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  }

  render() {
    const { viewModel, loading } = this.props;
    const { categorySearchOptions } = viewModel;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Typography type="headline">Filtro</Typography>
        <Loadable loading={loading}>
          <Row>
            <Col xs={12} md>
              <SelectField
                fullWidth
                label="Status do Produto"
                value={this.state.status}
                onChange={(_, value) => this.handleChange("status", value)}
                options={FilterView.status}
              />
            </Col>
            <Col xs={12} md>
              <SelectField
                fullWidth
                label="Tipo de Estoque"
                value={this.state.stock}
                onChange={(_, value) => this.handleChange("stock", value)}
                options={FilterView.inventories}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4}>
              <TextField
                fullWidth
                value={this.state.code}
                label="Código"
                onChange={(_, value) => this.handleChange("code", value)}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <TextField
                fullWidth
                value={this.state.name}
                label="Nome do Produto"
                onChange={(_, value) => this.handleChange("name", value)}
              />
            </Col>
            <Col xs={12} md={12} lg={4}>
              <EntitySelector
                label="Categoria"
                title="Selecionar Categoria"
                value={this.state.category.name}
                searchOptions={categorySearchOptions}
                onSelect={category => this.onSelectCategory(category)}
                parser={category => ({
                  key: category.uuid,
                  title: category.name
                })}
                nullSelection={{ uuid: "", name: "" }}
                dummyItem={{ uuid: null, name: "Sem categoria" }}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/filter/view.jsx